module.exports = __webpack_public_path__ + "static/media/bandeira_master.e17a7dab.svg";